'use client'

import { Major_Mono_Display, Space_Grotesk } from 'next/font/google'

const majorMono = Major_Mono_Display({
    weight: '400',
    subsets: ['latin'],
})

const spaceGrotesk = Space_Grotesk({ 
  subsets: ['latin'],
  weight: ['700']
})

// Add new base style classes for the text effect
const baseTextEffect = `
    transition-all duration-500
    text-transparent
    [-webkit-text-stroke:1px_#d6f4f4]
    hover:[-webkit-text-stroke:0.5px_#d6f4f4]
    hover:shadow-none
    cursor-pointer
`

const textShadowEffect = `
    [text-shadow:1px_1px_0px_#07bccc,2px_2px_0px_#e601c0,3px_3px_0px_#e9019a,4px_4px_0px_#f40468,2px_2px_3px_#482896]
    hover:[text-shadow:none]
`

// Add new inverted text effect classes
const invertedTextEffect = `
    relative z-[1]
    mix-blend-mode-difference
    text-white
    font-bold
    tracking-[-1px]
    uppercase
    leading-[0.9]
    [text-shadow:0_0_10px_rgba(255,255,255,0.2),-1px_-1px_0_#f7d032,1px_-1px_0_#f76432,-1px_1px_0_#32f7e1,1px_1px_0_#7132f7]
    transition-all duration-500
    cursor-pointer
`

export default function Logo({
    style = 'name',
    className = '',
    size = 'medium',
    path = '',
}) {
    const sizeClasses = {
        small: 'text-[clamp(0.875rem,2vw,1rem)] [-webkit-text-stroke:0.5px_#d6f4f4]',
        medium: 'text-[clamp(1.25rem,3vw,1.5rem)] [-webkit-text-stroke:0.75px_#d6f4f4]',
        large: 'text-[clamp(1.5rem,4vw,1.875rem)] [-webkit-text-stroke:1px_#d6f4f4]',
    }

    const renderLogo = () => {
        switch (style) {
            case 'abbreviated':
            case 'abbreviatedUrl':
                return (
                    <div className="flex items-center gap-2">
                        <div className={`
                            relative inline-flex items-center justify-center
                            font-bold
                            ${style === 'inverted' ? `${invertedTextEffect} ${spaceGrotesk.className}` : `${baseTextEffect} ${textShadowEffect} ${majorMono.className}`}
                            ${size === 'small' ? 'h-8' : size === 'medium' ? 'h-12' : 'h-16'}
                        `}>
                            <span>AF</span>
                        </div>
                        {style === 'abbreviatedUrl' && path && (
                            <span className={`
                                ${style === 'inverted' ? `${invertedTextEffect} ${spaceGrotesk.className}` : `${baseTextEffect} ${textShadowEffect} ${majorMono.className}`}
                                whitespace-nowrap
                            `}>
                                {style === 'inverted' ? `autofocused on ${path}` : `/${path}`}
                            </span>
                        )}
                    </div>
                )
            case 'url':
            case 'name':
            case 'inverted':
            default:
                return (
                    <span className={`
                        ${style === 'inverted' ? `${invertedTextEffect} ${spaceGrotesk.className}` : `${baseTextEffect} ${textShadowEffect} ${majorMono.className}`}
                        whitespace-nowrap
                    `}>
                        {style === 'url' 
                            ? `autofoc.us${path ? `/${path}` : ''}`
                            : style === 'inverted'
                                ? `autofocused on ${path}`
                                : 'Autofocus'
                        }
                    </span>
                )
        }
    }

    return (
        <div
            className={`
                ${sizeClasses[size]}
                ${className}
                w-full
            `}
        >
            {renderLogo()}
        </div>
    )
}
